"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classNames2 = _interopRequireDefault(require("../../utilities/classNames"));

var _core = require("../../core");

var _HeadingTypes = require("./HeadingTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Heading = function Heading(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      rank = _ref.rank,
      boldOrange = _ref.boldOrange,
      type = _ref.type,
      id = _ref.id,
      className = _ref.className,
      boldType = _ref.boldType,
      role = _ref.role;
  var getClassName = (0, _classNames2["default"])(Heading.displayName);
  var HeadingTag = "span";

  if (rank && Object.values(rank).includes(rank)) {
    HeadingTag = "h".concat(rank);
  }

  return /*#__PURE__*/_react["default"].createElement(HeadingTag, {
    className: getClassName({
      className: className,
      modifiers: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, type, true), _defineProperty(_classNames, align, align !== _core.Alignments.LEFT), _defineProperty(_classNames, "boldOrange", boldOrange), _defineProperty(_classNames, boldType, Boolean(boldType)), _classNames)),
      utilities: (0, _classnames["default"])({
        typographySmallCaps: type === _HeadingTypes.types.SmallCaps
      })
    }),
    id: id,
    role: role
  }, children);
};

Heading.displayName = "Heading";
Heading.defaultProps = {
  align: _core.Alignments.LEFT
};
var _default = Heading;
exports["default"] = _default;